import { TFunction } from 'i18next';
import { Icons, SVGIcon } from '../SVG';
import { HyperlinkTarget } from './Hyperlink.enums';

const check = (protocol: string, src?: string): boolean | undefined => src?.toLowerCase().startsWith(protocol);

export const isHttpProtocol = (src: string) => check('http', src);
export const isTelProtocol = (src: string) => check('tel:', src);
export const isMailProtocol = (src: string) => check('mailto:', src);
export const isFileProtocol = (src: string) => check('file:', src);

export type UrlProtocols = 'tel' | 'mailto' | 'file' | 'http' | undefined;
export const getUrlProtocol = (src?: string): UrlProtocols => {
  if (!src || typeof src !== 'string') {
    return undefined;
  }
  if (isHttpProtocol(src)) {
    return 'http';
  }
  if (isMailProtocol(src)) {
    return 'mailto';
  }
  if (isTelProtocol(src)) {
    return 'tel';
  }
  if (isFileProtocol(src)) {
    return 'file';
  }
};

export const getLinkItemIcon = (protocol: UrlProtocols): SVGIcon | undefined => {
  switch (protocol) {
    case 'mailto':
      return Icons.MAIL_ENVELOPE;
    case 'tel':
      return Icons.PHONE;
    case 'http':
      return Icons.EXTERNAL_LINK_ARROW;
    default:
      return undefined;
  }
};

export const getItemHelpText = (protocol: UrlProtocols, t: TFunction): string | undefined => {
  switch (protocol) {
    case 'mailto':
      return t('linkOpensEmail', { ns: 'phrases' });
    case 'tel':
      return t('linkOpensTel', { ns: 'phrases' });
    case 'http':
      return t('linkOpensInNewWindow', { ns: 'phrases' });
    default:
      return undefined;
  }
};

/**
 * Returns the target attribute according to a protocol.
 * some protocols always should have no target, e.g mailto and tel.
 */
export const getTarget = (url: string): string | undefined => {
  const protocol = getUrlProtocol(url);
  switch (protocol) {
    case 'http':
      return HyperlinkTarget.BLANK;
    case 'mailto':
    case 'tel':
    default:
      return undefined;
  }
};
